
import { useEffect, useState } from "react";
import { FiDownload } from "react-icons/fi";
import { SweetAlertSuccess, SweetAlertError } from '../../../components/sweetAlert/swetAlert.jsx';
import DataTable from "react-data-table-component";
import apiAdm from "../../../services/apiAdm.js";
import { saveAs } from 'file-saver';
import Alert from 'react-bootstrap/Alert';

function Fechamento() {
    const [isEntrada, setIsEntrada] = useState(false);
    const [isSaida, setIsSaida] = useState(false);
    const [isCte, setIsCte] = useState(false);
    const [isNFCe, setIsNFCe] = useState(false);
    const [isMovimento, setIsMovimento] = useState(false);
    const [mes, setMes] = useState(0);
    const [ano, setAno] = useState(0);
    const hoje = new Date();
    const empresas = JSON.parse(localStorage.getItem('empresas'));
    const [data1, setData1] = useState('');
    const [data2, setData2] = useState('');

    const columns = [

        {
            name: 'CNPJ',
            selector: row => row.cnpj,
            sortable: true,
            width: "15%",
        },
        {
            name: 'Nome fantasia',
            selector: row => row.nome,
            sortable: true,
            wrap: true,
            width: "40%",
        },

        {
            name: 'Razão social',
            selector: row => row.razao,
            sortable: true,
            width: "40%",
        },
    ];

    let anos = [
        {
            label: 'Informe o ano',
            value: 0
        },
    ];

    for (let i = 0; i < 5; i++) {
        anos.push({ label: hoje.getFullYear() - i, value: hoje.getFullYear() - i })
    };

    const [seletectRows, setSelectedRows] = useState([]);
    const [showAlert, setShowAlert] = useState(false);

    const handleSelectedRowsChange = (rows) => {
        setSelectedRows(rows.selectedRows);
    };
    function entradaChange(e) {
        setIsEntrada(e.target.checked);
    };
    function saidaChange(e) {
        setIsSaida(e.target.checked);
    };
    function cteChange(e) {
        setIsCte(e.target.checked);
    };
    function nfceChange(e) {
        setIsNFCe(e.target.checked);
    };

    function mesChange(e) {
        setMes(e.target.value);
    };
    function anoChange(e) {
        setAno(e.target.value);
    };

    async function Baixar() {
        if ((data1 == '') || (data2 == '')) {
            SweetAlertError({ texto: 'Falta informar o período de datas.' });
            return;
        };
        if (data1 > data2) {
            SweetAlertError({ texto: 'Período de datas incorreto.' });
            return;
        };


        if ((isEntrada === false) && (isSaida === false) && (isCte === false) && (isNFCe === false)) {
            SweetAlertError({ texto: 'Falta selecionar um dos documentos fiscais.' });
            return;
        };

        if (seletectRows.length == 0) {
            SweetAlertError({ texto: 'Falta selecionar a(s) empresa(s).' });
            return;
        };

        setIsMovimento(false);
        // Entradas
        await PreprarDownload();

    }

    async function PreprarDownload() {
        var empresas = [];
        for (var i = 0; i < seletectRows.length; i++) {
            empresas.push(seletectRows[i].idEntidade);
        };
        var tipos = [];
        if (isEntrada) {
            tipos.push('NFeE');
        };
        if (isSaida) {
            tipos.push('NFeS');
        };
        if (isCte) {
            tipos.push('CTe');
        };
        if (isNFCe) {
            tipos.push('NFCe');
        };

        let d1 = data1 + ' 00:00:00';
        let d2 = data2 + ' 23:59:59';

        const json = {
            empresas: empresas,
            data1: d1,
            data2: d2,
            tipos: tipos,
        };
        setShowAlert(true);
        await Download(json);
    };

    async function Download(data) {

        console.log(data);
        await apiAdm.post("/xmlresumo/fechamento", data, {
            responseType: 'blob', // 🔴 ESSENCIAL
            timeout: 300000
        })
            .then((res) => {
                console.log(res);

                let fileName = res.headers['x-filename'];
                const blob = new Blob([res.data], { type: 'application/zip' });
                const downloadUrl = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = downloadUrl;

                link.download = fileName; // Specify the desired file name
                document.body.appendChild(link);
                link.click();

                // 5. Clean up the temporary URL and element
                document.body.removeChild(link);
                window.URL.revokeObjectURL(downloadUrl);
                setShowAlert(false);
            })
            .catch((err) => {
                console.log(err);
                if (err.response.status !== 404) {
                    SweetAlertError({ texto: "Falha ao gerar o fechamento. " + err });
                };
                setShowAlert(false);
            });


    }
 useEffect(() => {
    console.log(empresas);
}, []);

    return <>
        <div className="container-fluid">
            <div className="row flex-nowrap">
                <div className="col-auto col-md-3 col-xl-2 px-sm-2 px-0"></div>
                <div className="row">
                    <div className="col-md-10 py-3">
                        <div className="card">
                            <div className="card-body">
                                <div className="row d-block" style={{ padding: "10px" }}>
                                    <Alert variant="success" show={showAlert} onClose={() => setShowAlert(false)}>
                                        <Alert.Heading>Aguarde...</Alert.Heading>
                                        <p>
                                            Sua solicitação está sendo processada.
                                        </p>
                                    </Alert>
                                </div>
                                <h5 className="text-muted mb-3">Fechamento</h5>



                                <div className="accordion" id="accordionExample">
                                    <div className="accordion-item">
                                        <h2 className="accordion-header" id="headingOne">
                                            <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne"
                                                aria-expanded="false" aria-controls="collapseOne">
                                                Selecione as empresas desejadas para download dos arquivos
                                            </button>
                                        </h2>

                                        <div id="collapseOne" className="accordion-collapse collapse" aria-labelledby="headingOne"
                                            data-bs-parent="#accordionExample">
                                            <div className="accordion-body">
                                                <div className="container">
                                                    <div className="table-responsive">
                                                        <DataTable
                                                            columns={columns}
                                                            data={empresas}
                                                            keyField="idEntidade"    
                                                            paginationServer={true}
                                                            highlightOnHover
                                                            pointerOnHover
                                                            selectableRows
                                                            dense
                                                            onSelectedRowsChange={handleSelectedRowsChange}
                                                        />

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <br />
                                <div className="row">
                                    <div className="row mb-3">
                                        <div className="col-sm-2">
                                            <label className="text-secondary">A partir do dia</label>
                                            <input type="date" className="form-control" onChange={(e) => setData1(e.target.value)} value={data1} />
                                        </div>
                                        <div className="col-sm-2">
                                            <label className="text-secondary">Até o dia</label>
                                            <input type="date" className="form-control" onChange={(e) => setData2(e.target.value)} value={data2} />

                                        </div>
                                    </div>

                                    {/* <div className="col-sm-2">
                                        <select className="form-select" onChange={mesChange}>
                                            <option value="0">Mes</option>
                                            <option value="1">Janeiro</option>
                                            <option value="2">Fevereiro</option>
                                            <option value="3">Março</option>
                                            <option value="4">Abril</option>
                                            <option value="5">Maio</option>
                                            <option value="6">Junho</option>
                                            <option value="7">Julho</option>
                                            <option value="8">Agosto</option>
                                            <option value="9">Setembro</option>
                                            <option value="10">Outubro</option>
                                            <option value="11">Novembro</option>
                                            <option value="12">Dezembro</option>

                                        </select>

                                    </div>

                                    <div className="col-sm-2">
                                        <select className="form-select" onChange={anoChange}>
                                            {anos.map((ano) => (
                                                <option value={ano.value}>{ano.label}</option>
                                            ))}
                                        </select>
                                    </div> */}
                                    <div className="row">

                                        <div className="col-sm-2">
                                            <input type="checkbox" onChange={entradaChange} style={{ marginTop: 12 }} /> NF-e Entradas?
                                        </div>
                                        <div className="col-sm-2">
                                            <input type="checkbox" onChange={saidaChange} style={{ marginTop: 12 }} /> NF-e Saídas?

                                        </div>
                                        <div className="col-sm-2">
                                            <input type="checkbox" onChange={cteChange} style={{ marginTop: 12 }} /> CT-e?
                                        </div>
                                        <div className="col-sm-2">
                                            <input type="checkbox" onChange={nfceChange} style={{ marginTop: 12 }} /> NFC-e?
                                        </div>

                                        <div className="btn-opcoes col-3" >
                                            <button type="button" className="btn btn-primary float-end mr-1"
                                                onClick={() => Baixar()}>
                                                <FiDownload /><span> Baixar </span>
                                            </button>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>

        </div>

    </>
};

export default Fechamento;
